import React from 'react';

export const OrganizerContext = React.createContext('');
